import { useEffect, useState } from 'react'

// Whether the person asked for less motion (the OS's "reduce motion"). CSS
// already guards every animation with @media (prefers-reduced-motion); a
// component that animates also reads it here, so the still version is the
// one rendered (a class or data attribute), not only the one styled -- and
// so a test can pin it (jsdom evaluates no media queries).
const QUERY = '(prefers-reduced-motion: reduce)'

const media = () => {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null
  } catch (e) {
    return null
  }
}

export const prefersReducedMotion = () => {
  const list = media()
  return !!(list && list.matches)
}

// The same, followed: a change in the OS setting while the page is open
// re-renders the reader.
export const useReducedMotion = () => {
  const [reduced, setReduced] = useState(prefersReducedMotion)

  useEffect(() => {
    const list = media()
    if (!list) return undefined
    const onChange = () => setReduced(!!list.matches)
    onChange()
    if (typeof list.addEventListener === 'function') {
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    }
    if (typeof list.addListener === 'function') {
      list.addListener(onChange)
      return () => list.removeListener(onChange)
    }
    return undefined
  }, [])

  return reduced
}
